<template>
  <v-row
    align-center
    :style="isEnabled(userData.isEnabled)"
    class="strategio-user-list-item"
    @click="adminUser(userData.userID)"
  >
    <v-col cols="12" md="2" align-self="center">
      <v-row justify="center">
        <v-chip
          small
          class="ml-0"
          :color="pickColor(userData.userType)"
          :style="[
            {'color': 'white'},
            {'width': getChipWidth()},
            {'justify-content': 'center'}
          ]"
        >{{userData.userType}}</v-chip>

      </v-row>
    </v-col>

    <v-col cols="12" md="3" >
      <img height="31px" :src="require('@/assets/manage-users-icons/user.png')" alt="user-icon">
      <strong>{{userData.isEnabled ? "" : "[Deshabilitado] "}}{{userData.name}}</strong>
    </v-col>

    <v-col cols="12" md="7" class="py-0 my-2" align-self="center">
      <v-row>
        <v-col cols="12" sm="6" class="py-0 my-2">
          <v-row align-content="end">
            <v-col cols="12" md="2" class="py-0">
              <img height="31px" :src="require('@/assets/manage-users-icons/position.png')" alt="user-icon">
            </v-col>
            <v-col cols="12" md="10" class="py-0 pb-1">
              <strong>{{userData.description}}</strong>
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="12" sm="6" class="py-0 my-2">
          <v-row align-content="end">
            <v-col cols="12" md="2" class="py-0">
              <img height="30px" :src="require('@/assets/manage-users-icons/email.png')" alt="user-icon">
            </v-col>
            <v-col cols="12" md="10" class="py-0 pb-1">
              <span class="grey--text" ellipsis>{{userData.mail}}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

  </v-row>

</template>

<script>

export default {
  name: 'users-list-item',
  props: ['userData'],
  methods: {
    isEnabled (isEnabled) {
      return 'opacity: ' + (isEnabled ? '1' : '0.5')
    },
    getChipWidth () {
      let widthio = ''
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          widthio = '70%'
          break
        case 'md':
        case 'lg':
        case 'xl':
          widthio = '150px'
          break
        default:
          // widthio = ''
          break
      }

      return widthio
    },
    pickColor (userType) {
      switch (userType) {
        case 'ADMIN': return 'blue darken-1'
        case 'SUPERVISOR': return 'amber darken-1'
        case 'GLOBAL': return 'light-green darken-1'
        case 'NORMAL': return 'cyan darken-1'
        case 'DEMO': return 'purple darken-1'
        default: return 'grey darken-1'
      }
    },
    adminUser (userID) {
      this.$router.push(`/user/admin/${userID}`)
    }
  }
}
</script>

<style>
.strategio-user-list-item {
  padding: 12px 16px 12px 16px !important;
  cursor: pointer;
}
.strategio-user-list-item:hover {
  background-color: rgb(224, 224, 224);
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/users-list-item.vue